import { ReactElement } from "react"

import NotAuthorised from "../components/fallback/notAuthorised"
import {
    IDENTIFIER_TYPE_INSTALLER_TAG,
    INSTALLER_APPROVED,
    CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY,
} from "../constants/roles"
import { useGetUserData } from "../hooks/useGetUserData"

type IRequireRolesProps = {
    requiredRoles: string[]
    children: ReactElement
}

/**
 * Checks if an authenticated user has the correct role to access a given
 * webpage. If not, redirects user to fallback not authorized webpage.
 * Returns null while user data is still loading to prevent a flash of
 * "Access Denied" during page refresh.
 */
const RequireRoles = ({
    requiredRoles,
    children,
}: IRequireRolesProps): ReactElement | null => {
    const { groups, isConfiguring } = useGetUserData()

    if (isConfiguring) {
        return null
    }

    const hasRequiredRole = groups.some((userRole) =>
        requiredRoles.includes(userRole)
    )

    if (
        requiredRoles.includes(
            CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY
        )
    ) {
        if (
            groups.some((group) =>
                group.includes(IDENTIFIER_TYPE_INSTALLER_TAG)
            ) &&
            !groups.includes(INSTALLER_APPROVED)
        ) {
            return <NotAuthorised />
        }
    } else if (!hasRequiredRole) {
        return <NotAuthorised />
    }
    return children
}

export default RequireRoles
